import React from "react";
import Layout from "components/Layout";
import TermBlocks from "components/TermBlocks";
import Padder from "components/Padder";
import Footer from "components/Footer";

const PAGE_CONFIG = [
  {
    header: "",
    blocks: [
      {
        header: "",
        blocks: [
          `This website or its third-party tools process personal data (e.g. browsing data or IP addresses) and use cookies or other identifiers, which are necessary for its functioning. You accept the use of cookies or other identifiers by closing or dismissing the cookie notice, by clicking a link or button or by continuing to browse otherwise.`
        ]
      },
      {
        header: "",
        component: () => (
          <div className="pv4">
            <div className="overflow-auto">
              <table className="f6 w-100 mw8 center" cellSpacing="0">
                <thead>
                  <tr>
                    <th className="fw6 bb b--black-20 tl pb3 pr3 bg-white">
                      Types of cookie
                    </th>
                    <th className="fw6 bb b--black-20 tl pb3 pr3 bg-white">
                      Who serves these cookies
                    </th>
                    <th className="fw6 bb b--black-20 tl pb3 pr3 bg-white">
                      How to refuse
                    </th>
                  </tr>
                </thead>
                <tbody className="lh-copy">
                  <tr>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Essential website cookies: These cookies are strictly
                      necessary to provide you with services available through
                      our Websites and to use some of its features, such as
                      access to secure areas.
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      DevPlan, Inc
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Because these cookies are strictly necessary to deliver
                      the Websites to you, you cannot refuse them. You can block
                      or delete them by changing your browser settings however,
                      as described below under the heading "How can I control
                      cookies?".
                    </td>
                  </tr>
                  <tr>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Performance and functionality cookies: These cookies are
                      used to enhance the performance and functionality of our
                      Websites but are non-essential to their use. However,
                      without these cookies, certain functionality like chat
                      support may become impacted.
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Intercom, Goolge reCAPTCHA
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      To refuse these cookies, please follow the instructions
                      below under the heading "How can I control cookies?"
                    </td>
                  </tr>
                  <tr>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Analytics and customisation cookies: These cookies collect
                      information that is used either in aggregate form to help
                      us understand how our Websites are being used or how
                      effective are marketing campaigns are, or to help us
                      customise our Websites for you.
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Google Analytics
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      To refuse these cookies, please follow the instructions
                      below under the heading "How can I control cookies?"
                      Alternatively, please click on the relevant opt-out link
                      below: Google Analytics
                    </td>
                  </tr>
                  <tr>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Advertising cookies: These cookies are used to make
                      advertising messages more relevant to you. They perform
                      functions like preventing the same ad from continuously
                      reappearing, ensuring that ads are properly displayed for
                      advertisers, and in some cases selecting advertisements
                      that are based on your interests.
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      Facebook Custom Audience, Google AdWords Conversion,
                      Google Dynamic Remarketing
                    </td>
                    <td className="v-top pv3 pr3 bb b--black-20">
                      To refuse these cookies, please follow the instructions
                      below under the heading "How can I control cookies?"
                      Alternatively, please click on the relevant opt-out link
                      below:{" "}
                      <span>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link__decoration--hover color-primary link"
                          href="https://www.facebook.com/policy/cookies/"
                        >
                          Facebook Custom Audience
                        </a>
                      </span>
                      : Instructions on how to opt out are provided here{" "}
                      <span>
                        <a
                          target="_blank"
                          className="link__decoration--hover color-primary link"
                          rel="noopener noreferrer"
                          href="http://www.google.com/settings/ads/anonymous?sig=ACi0TCjb6JuLnceXPNZc6pnrxNwYKORzihhM2FMOrlEfzXDxXQpxlHUrp1hdMV08pYNqcaREwF3vPcEGkW5ZfpvC1lH0JQ92McenhVPQxWHasPDQxiwrJck&hl=en"
                        >
                          Google AdWords Conversion
                        </a>
                      </span>{" "}
                      Google Dynamic Remarketing: same as above.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      },
      {
        header: "How can I control cookies?",
        blocks: [
          `Users can provide or withdraw consent to the use of Cookies and other Identifiers by setting their preferences via the cookie notice. Additionally, Users can manage preferences regarding Identifiers directly from within their own device settings and prevent – for example – the storing of third-party Identifiers. It is also possible, via relevant browser or device features, to delete previously stored Identifiers, including those used to remember the User’s initial consent. You can exercise your cookie preferences by clicking on the appropriate opt-out links provided in the cookie table above.
          You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our Websites and/or App and/or platform though your access to some functionality and areas may be restricted. As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.
          In addition, most advertising networks offer you a way to opt out of targeted advertising. If you would like to find out more information, please visit http://www.aboutads.info/choices/ or http://www.youronlinechoices.com. More education content on what cookies are can be seen here: https://www.cookiesandyou.com/`
        ]
      },
      {
        header: "Feedback",
        blocks: [
          `We welcome and encourage you to provide feedback, comments and suggestions for improvements to the PriceBlocs Service ("Feedback"). You may submit Feedback by emailing us at info@priceblocs.com and where available, using a live chat feature within the app. You acknowledge and agree that all Feedback will be the sole and exclusive property of PriceBlocs and you hereby irrevocably assign to PriceBlocs and agree to irrevocably assign to PriceBlocs all of your right, title, and interest in and to all Feedback, including without limitation all worldwide patent rights, copyright rights, trade secret rights, and other proprietary or intellectual property rights therein. At PriceBlocs's request and expense, you will execute documents and take such further acts as PriceBlocs may reasonably request to assist PriceBlocs to acquire, perfect, and maintain its intellectual property rights and other legal protections for the Feedback.`
        ]
      }
    ]
  }
];

const Terms = () => (
  <Layout>
    {() => (
      <div className="mw8 center pt5">
        <div className="ph3">
          <article>
            <div className="f1 fw5">Cookie Policy</div>
            <div className="f6 pt2 lh-copy">Last updated Oct 20th, 2020</div>
          </article>
          <TermBlocks config={PAGE_CONFIG} />
          <Padder customClasses="dib h4 w-100" />
          {/* <!-- Footer  --> */}
        </div>
        <div className="hairline-1 bt">
          <Footer />
        </div>
      </div>
    )}
  </Layout>
);

export default Terms;
